module.exports = __webpack_public_path__ + "media/images/sample/product-9-8e92d2d60d4e841a83d6f09f2279dd15.png";